import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Radio } from '../common'
import { Row, Col } from 'reactstrap';

class QuestionItem extends Component{

  render() {
    const { data, hanndleResponse, select_option } = this.props;

    return (
      <>
        <Row className="item question-item text-center">
          <Col xl={{ size: 8}} className='mx-auto'>
            <h1 className="h3 libre-caslon-text-regular font-weight-normal mb-5">{ data.name }</h1>
            <div className="mx-auto mb-5 rounded-circle border d-inline-block p-3">
              <img src={data.icon_invert} width="100" height="100" alt={ data.name } className='img-fluid'/>
            </div>
            <p className="mb-2 h4 font-weight-semibold">{data.question}</p>
            <p className='text-muted mb-5'>{data.description}</p>

            <div className="question-item-nav border-primary border rounded py-3 px-md-4 px-2 d-inline-block mx-auto">
              <p className="font-weight-medium h5 mb-3">It gives me energy...</p>
              <div className="d-flex justify-content-center">
                <div className="btn-group btn-group-toggle">
                  <Radio handleRadioChange={hanndleResponse} item_id={data.id} group="gives_me_energy_" select_option={select_option} label="Always" value="1" />
                  <Radio handleRadioChange={hanndleResponse} item_id={data.id} group="gives_me_energy_" select_option={select_option} label="Sometimes" value="2" />
                  <Radio handleRadioChange={hanndleResponse} item_id={data.id} group="gives_me_energy_" select_option={select_option} label="Never" value="3" />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state, props) => {
  return { };
};

const mapDispatchToProps = {
};

export default  connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionItem)
